import { useEffect, useState } from "react";
import {
  AddTowallet,
  RemoveFromwallet,
} from "../services/admin.transaction.service";
import { getClients } from "../services/client.service"; 
import { useToast } from "../context/ToastContext";
import Select from "react-select";
import {
  Wallet as WalletIcon,
  ArrowUpCircle,
  ArrowDownCircle,
  Info,
} from "lucide-react";
import { resolveMedia } from "../services/api";
import defaultAvatar from "../assets/logo/logo.png";
import "../styles/wallet.css";

export default function Wallet() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClient, setSelectedClient] = useState(null);
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("increase");
  const { showToast } = useToast();

  useEffect(() => {
    loadClients();
  }, []);

 async function loadClients() {
    try {
      const response = await getClients();
      const clientsArray = Array.isArray(response) ? response : (response?.data || []);
      const options = clientsArray.map((c) => ({
        value: c.user?.id,
        label: `${c.user?.firstName} ${c.user?.lastName}`,
        clientData: c,
      }));
      setClients(options);
    } catch (err) {
      console.error("Erreur chargement clients:", err);
      showToast("Impossible de charger la liste des clients", "error");
    } finally {
      setLoading(false);
    }
  }

  const formatOptionLabel = ({ label, clientData }) => (
    <div className="selectUserOption">
      <img
        src={resolveMedia(clientData.user?.profilPicture, defaultAvatar)}
        alt=""
        className="selectAvatar"
      />
      <div className="selectUserInfo">
        <div className="selectUserName">{label}</div>
        <div className="selectUserSub">
          {clientData.user?.username} • {clientData.balance.toLocaleString()}{" "}
          CFA
        </div>
      </div>
    </div>
  );

  async function handleSubmit(e) {
    e.preventDefault();
    if (!selectedClient)
      return showToast("Veuillez choisir un client", "error");

    const payload = {
      id_user: selectedClient.value,
      amount: Number(amount),
      description: description,
    };

    try {
      if (type === "increase") {
        await AddTowallet(payload);
        showToast("Recharge effectuée", "success");
      } else {
        await RemoveFromwallet(payload);
        showToast("Retrait effectué", "success");
      }

      setAmount("");
      setDescription("");
      setSelectedClient(null);
      loadClients();
    } catch (err) {
      showToast(
        err.response?.data?.message || "Erreur lors de la transaction",
        "error",
      );
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <WalletIcon size={28} className="primaryIcon" />
            <h2>Gestion du Portefeuille</h2>
          </div>
        </div>
      </div>

      <div className="walletContainer">
        <div className="walletCard">
          <form onSubmit={handleSubmit}>
            <div className="formSection">
              <label>Type d'opération</label>
              <div className="transactionTypeToggle">
                <button
                  type="button"
                  className={`toggleBtn ${type === "increase" ? "active increase" : ""}`}
                  onClick={() => setType("increase")}
                >
                  <ArrowUpCircle size={22} /> Recharge
                </button>
                <button
                  type="button"
                  className={`toggleBtn ${type === "decrease" ? "active decrease" : ""}`}
                  onClick={() => setType("decrease")}
                >
                  <ArrowDownCircle size={22} /> Retrait
                </button>
              </div>
            </div>

            <div className="formSection">
              <label>Client à débiter/créditer</label>
              <Select
                options={clients}
                value={selectedClient}
                onChange={setSelectedClient}
                formatOptionLabel={formatOptionLabel}
                placeholder="Rechercher par nom, téléphone ou identifiant..."
                classNamePrefix="customSelect"
                isLoading={loading}
                styles={{
                  control: (base) => ({
                    ...base,
                    padding: "8px",
                    borderRadius: "12px",
                    borderColor: "#e2e8f0",
                  }),
                }}
              />
            </div>
            <div className="formGrid">
              <div className="formGroup">
                <label>Montant de l'opération (CFA)</label>
                <input
                  type="number"
                  className="largeInput"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Ex: 50 000"
                  required
                />
              </div>
              <div className="formGroup">
                <label>Motif de la transaction</label>
                <input
                  type="text"
                  className="largeInput"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Ex: Versement espèce agence"
                  required
                />
              </div>
            </div>

            {selectedClient && (
              <div className="infoBox">
                <Info size={24} color="#fab005" />
                <div>
                  <p style={{ margin: 0 }}>
                    Solde actuel de <strong>{selectedClient.label}</strong>
                  </p>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      color: "#333",
                    }}
                  >
                    {selectedClient.clientData.balance.toLocaleString()} CFA
                  </span>
                </div>
              </div>
            )}

            <button type="submit" className={`btnSubmit ${type}`}>
              Valider {type === "increase" ? "le rechargement" : "le retrait"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
